module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ackhd2"
  }, [_vm._v("HAPPY CREATING")]), _vm._v(" "), _c('p', {
    staticClass: "ack"
  }, [_c('span', {
    staticClass: "grey"
  }, [_vm._v("I dedicate this book to all of my students, both past and present. Thank you for giving me this opportunity to share my knowledge with you. May you always find the time to enjoy the creative adventure.")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg3-1.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption"
  }, [_vm._v("One-Hour Flower")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cdcc380","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_Fm_happy.vue
// module id = 69
// module chunks = 0